import {authHeader} from '../helpers/auth-header';
import { handleResponse } from '../helpers';

const BASE_URL = process.env.REACT_APP_API_URL;

export const apiService = {
    getAllProducts,
}

function getAllProducts() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(BASE_URL + '/data/products', requestOptions)
        .then(handleResponse)
        .then(response => {
            if (response.Success) {
                return response.Data;
            }
           return {}
        })
        .catch(err => console.log(err));
}